<template>
  <div>
    <!-- 顶部 -->
    <!-- <div class="top" v-if="cookies.length<=1">
      <div class="textRight">您好，欢迎来到山东水产学会标准化信息管理平台！
      <button class="login" @click="loginbutton"><a class="login" style="color:white;font-weight:normal">登录</a></button>
      <button class="enroll" @click="zcbutton"><a class="enroll" style="color:white;font-weight:normal">注册</a></button>
      </div>
    </div> -->
    <!-- <div class="top" v-if="cookies.length>1">
      <div class="textRight">欢迎您，{{username}}！
      <a class="logout" @click="logout">退出</a>
      </div>
    </div> -->
    <!-- headerlogo -->
    <div>
      <div class="header">
        <div class="textRight" ><!--v-if="cookies.length<=1"--><!--欢迎来到山东水产学会标准化信息管理平台！-->
      </div>
      <!--<div class="textRightL" v-if="cookies.length>1">
        欢迎您，{{username}}！
        <a class="logout" @click="logout">退出</a>
      </div>-->
      </div>

    </div>
    <div style="width: 140px;height: 236px;background: #ffffff;position: fixed;right: 0;top: 260px;text-align: center;opacity: 0.9;">
      <div style="margin-top: 10px;">
        <!-- <img src="../../images/096e724fb4c9cd7227aebd52c6f38351.jpeg" width="85px"> -->
        <img src="../../images/loginavatar.png" width="85px">
      </div>
      <div style="margin-top: 20px;" v-if="cookies.length<=1">
        欢迎您，请登录！
      </div>
      <div style="margin-top: 20px;" v-if="cookies.length>1">
        欢迎您，{{username}}！
        <div>
          <a-button size="large" type="primary" class="login-button" style="width:90%;margin-top: 20px;background: #ff7875;border:#ff7875;" @click="logout" >
            退出登录
          </a-button>
        </div>
      </div>
      <a-button size="large" v-if="cookies.length<=1" type="primary" class="login-button" style="width:90%;background:#00488a;border:#00488a;margin-top: 20px;" @click="loginbutton" >
        登录/注册
      </a-button>
    </div>
    <!-- 菜单 -->
    <div class="menuwrap" >
      <div class="menu" ref="menu">
        <!-- <ul> -->
          <li :class="[path=='/home'?'active':path=='/aquaticstate' || (path.startsWith('/aquaticstate'))?'lastli':'']" ><router-link to="/">首页</router-link>
          <!-- <a href="/home">首页</a> -->
          </li>
          <li :class="[(path.startsWith('/aquaticstate')) || (path.startsWith('/statedetial'))?'active':(path=='/aquaticstandards')?'lastli':'']">
            <router-link to="/aquaticstate">标准动态</router-link></li>
          <li :class="[(path=='/aquaticstandards') || (path.startsWith('/aquaticstandardsdetial'))?'active':(path=='/aquaticspecial') ||
          (path.startsWith('/aquaticspecial'))?'lastli':'']">
            <router-link to="/aquaticstandards">水产标准</router-link>
          </li>
          <li :class="[(path=='/aquaticspecial') || (path.startsWith('/aquaticspecial'))?'active':(path=='/aquatictrain') || (path.startsWith('/aquatictrain'))?'lastli':'']">
            <router-link to="/aquaticspecial">水产专题</router-link>
          </li>
          <li :class="[(path=='/aquatictrain') || (path.startsWith('/aquatictrain'))?'active':path=='/aquaticzxfw'?'lastli':'']">
            <router-link to="/aquatictrain">培训宣贯</router-link></li>
          <li :class="[(path=='/aquaticzxfw') || (path.startsWith('/aquaticzxfw'))?'active':(path=='/aquaticexperts') ||
          (path.startsWith('/aquaticexperts'))?'lastli':'']">
            <router-link to="/aquaticzxfw">咨询服务</router-link></li>
          <li :class="[(path=='/aquaticexperts') || (path.startsWith('/aquaticexperts'))?'active':path=='/aquaticcommission'?'lastli':'']">
            <router-link to="/aquaticexperts">专家库</router-link></li>

          <!-- <li :class="[path=='/aquatictrain'?'active':'']"><router-link to="/aquatictrain">培训宣贯</router-link></li>
          <li :class="[path=='/aquaticzxfw'?'active':path=='/aquaticzxfw'?'lastli':'']"><router-link to="/aquaticzxfw">咨询服务</router-link></li>
          <li :class="[path=='/aquaticexperts'?'active':path=='/aquaticcommission'?'lastli':'']"><router-link to="/aquaticexperts">专家库</router-link></li> -->

          <li :class="[path=='/aquaticcommission'?'active lastli':'lastli']">
            <router-link to="/aquaticcommission">水产委会</router-link>
          </li>
          <!--<li  @click="loginbutton">
            <router-link to="">登录</router-link>
          </li>
          <li class="lastli" @click="zcbutton">
            <router-link to="">注册</router-link>
          </li>-->
        <!-- </ul> -->
      </div>
    </div>
    <div >
      <router-view class="rou"/>
    </div>
    <!-- 底部 -->

      <div>
      <div class="footerWrap">
      <div class="footer">
        <div>
        <div style="margin-top:1px;">
        <img src="../../images/icon_copy.png" >
        <span style="font-size: 27px;">山东水产学会</span></div>
        <div style="margin-left:5px;font-weight:bold;color:#a8a8a8;margin-top:8px;">服务热线 0531-82959468</div>
        <div style="margin-left:5px;font-weight:bold"></div>
        </div>
        <div class="footersx"></div>
        <div style="margin-left:5px;color:#a8a8a8;margin-top:5px;">
          <span style="font-size:15px">建议使用 Internet Explorer 11.0及以上浏览器访问本站 &nbsp;Copyright@ 2022山东水产学会标准化信息管理平台</span><br>
          <span style="font-size:15px">版权所有：山东水产学会 &nbsp;&nbsp;&nbsp;鲁ICP备2021003681号</span>
        </div>
        <div style="margin-left:130px;margin-top:15px"><img src="../../images/ewm_copy.png" style="width:80%">
        <div style="font-size:15px;color:#a8a8a8;margin-left:7px;">关注公众号</div></div>
      </div>
      </div>
      </div>
      <div>
      <a-back-top />
    </div>
    <Login ref="login" @ok="loginok"></Login>
    <Register ref="register" @ok="modalok"></Register>
  </div>
</template>



<script>
import Login from '../login/Login.vue'
import http from '../../js/axios'
import Register from '../login/Register.vue'

export default {
  name: 'App',
  components: {
  Login,
  Register
  },
  data(){
    return{
      animate: false,
      showNum: 9, // 可见列表条数
      list: [
        '轮播课程标题轮播课程标题轮播课程标题1',
        '轮播课程标题轮播课程标题轮播课程标题2',
        '轮播课程标题轮播课程标题轮播课程标题3',
        '轮播课程标题轮播课程标题轮播课程标题4',
        '轮播课程标题轮播课程标题轮播课程标题5',
        '轮播课程标题轮播课程标题轮播课程标题6',
        '轮播课程标题轮播课程标题轮播课程标题7',
        '轮播课程标题轮播课程标题轮播课程标题8'
      ],
      username:'',
      cookies:[]
    }
  },
  computed:{
    text() {
    return {
        id: this.number,
        val: this.arr[this.number]
      }
    }
  },
  watch:{
    $route: {
        immediate: true,
        handler() {
          this.path = this.$route.fullPath
        }
      }

  },
  created(){
    // 页面显示
    setInterval(this.showMarquee, 3000)
    this.path = this.$route.fullPath
    this.querycookie()
    this.addLog()
    var date = new Date('2022')
    var time1 = date.getTime()
  },
  mounted () {
    // 可见数据高度
    // this.$refs.marquee_box.style.height = this.showNum * 30 + 'px'
  },
  methods:{
    addLog(){
      var arr = document.cookie.split('; ');
        if(arr.length>1){
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'realname') {
                //  console.log(arr2[1])
                  this.username = arr2[1]; //保存到保存数据的地方
              }
          }
        }else{
          this.username = null
        }
      let user = {
        username: this.username,
      }
      http.addlog(user
      ).then((res) => {
      })
    },
    zcbutton(){
      this.$refs.register.showModal()
    },
    modalok(){
      this.querycookie()
    },
    loginok(result){
      this.querycookie()
    },
    querycookie(){
      var arr = document.cookie.split('; ');
      this.cookies=arr
        if(arr.length>0){
          for (var i = 0; i < arr.length; i++) {
              var arr2 = arr[i].split('='); //再次切割
              //判断查找相对应的值
              if (arr2[0] == 'realname') {
                  this.username = arr2[1]; //保存到保存数据的地方
              }
          }
        }
    },
    logout(){
      http.get('/logout',{}
      ).then((res) => {
          this.$message.success(res.data.message);
          this.resetSetItem("islogin", "2");
          this.querycookie()
      })
    },
    loginbutton(){
      this.$refs.login.showModal()
    },
    button(){
      console.log("点击一次！")
    },
    // 处理数组方法
    showMarquee () {
      this.animate = true
      this.list.push(this.list[0])
      setTimeout(() => {
        this.list.shift()
        this.animate = false
      }, 1000)
    }
  }
}
</script>


<style>
  @import "../../config/common.css"


/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 15px; */


</style>



// WEBPACK FOOTER //
// src/views/dashboard/Analysis.vue